import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Seq } from 'immutable';

import { imageCdnAsset } from 'lib/common/url-helpers';

import LineItems from 'components/common/line-items';
import OrderTotal from 'components/common/order-total';
import RefundOverlay from 'components/receipt/refund-overlay';

import Bookings from 'models/bookings';
import ReceiptModel from 'models/receipt';
import UserModel from 'models/user';
import { Location } from 'models/locations';

const propTypes = {
  bookings: PropTypes.instanceOf(Seq.Keyed),
  receipt: PropTypes.instanceOf(ReceiptModel),
  user: PropTypes.instanceOf(UserModel),
  location: PropTypes.instanceOf(Location).isRequired,
};

const defaultProps = {
  bookings: Bookings(),
  receipt: new ReceiptModel(),
  user: new UserModel(),
};

class PurchaseSummary extends Component {
  purchaseTime() {
    const { receipt } = this.props;
    if (receipt.purchaseTime) {
      return receipt.purchaseTime.format('MMMM D, YYYY');
    }

    return null;
  }

  renderPassNumbers() {
    const passNumbers = this.props.bookings.toIndexedSeq().map(booking => (
      <dd key={`pass-number-${booking.id}`}>{booking.id}</dd>
    ));

    return (
      <dl>
        <dt>PARKING PASS #</dt>
        {passNumbers}
      </dl>
    );
  }

  renderExpenseMemo() {
    const { bookings, receipt } = this.props;
    const memos = bookings.toIndexedSeq().map((booking) => {
      if (receipt.expenseMemo) {
        return <dd key={`expense-memo-${booking.id}`}>{receipt.expenseMemo}</dd>;
      }
      return null;
    }).filter(o => o);

    if (memos.size === 0 || !receipt.expenseMemo) { return null; }

    return (
      <dl>
        <dt>MEMO</dt>
        {memos.first()}
      </dl>
    );
  }

  render() {
    const { receipt, user, location } = this.props;
    return (
      <div>
        { /* We have to wrap this in another div to get the jaggies to show up in print. */ }
        <img src={imageCdnAsset('/images/checkout/print-receipt-jaggies.png')} className="visible-print-block" alt="" />
        <div className="purchase-receipt shadowed">
          <div className="receipt-title">PARKING CHARGES</div>
          <div className="receipt-customer">Purchased by {user.name} on {this.purchaseTime()}</div>
          {this.renderPassNumbers()}
          <dl>
            <dt>PAYMENT TYPE</dt>
            <dd>{receipt.paymentType}</dd>
          </dl>
          {this.renderExpenseMemo()}
          <hr className="light-dash" />
          <div className="receipt-items">
            <RefundOverlay booking={this.props.bookings.first()} location={location} />
            <LineItems
              {...receipt.toLineItemProps()}
              type="receipt"
              location={location}
            />
            <hr className="double-line" />
            <OrderTotal
              label="TOTAL PURCHASE"
              amount={`${receipt.finalPrice}`}
              location={location}
            />
          </div>
        </div>
      </div>
    );
  }
}

PurchaseSummary.propTypes = propTypes;
PurchaseSummary.defaultProps = defaultProps;

export default PurchaseSummary;
